module.exports = __webpack_public_path__ + "img/ep2-10-2.89f0776a.png";